__turbopack_context__.v({
  "className": "fraunces_bb8f8efc-module__LBoKEG__className",
  "variable": "fraunces_bb8f8efc-module__LBoKEG__variable",
});
